import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import translations from '../assets/i18n/en.json';
import { ENV_CONSTS } from './env-consts.ts';

const siteType = ENV_CONSTS.SITE_TYPE;

export const supportedLanguages = ['en'] as const;

export const resources = {
  en: {
    translation: {
      ...translations.common,
      ...translations[siteType],
    },
  },
} as const;

export type TranslationKey = keyof (typeof resources)['en']['translation'];

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

// noinspection JSUnusedGlobalSymbols
export default i18n;
